"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPsychologicalProfileSchema = exports.PsychologyProcessingResultSchema = exports.ResponseFramingSchema = exports.BeliefSystemDetectionSchema = exports.PsychologicalApproachSchema = void 0;
const zod_1 = require("zod");
// CRITICAL: Psychology types are INTERNAL ONLY - never expose to frontend
// These types should only be used in backend psychology engine
// Psychological Approach Strategies
exports.PsychologicalApproachSchema = zod_1.z.enum([
    'curiosity_validation',
    'parental_empathy',
    'economic_validation',
    'social_proof',
    'authority_respect',
    'gradual_evidence',
    'community_integration',
    'personal_relevance'
]);
// Belief System Detection (INTERNAL ONLY)
exports.BeliefSystemDetectionSchema = zod_1.z.object({
    primary: zod_1.z.string(),
    confidence: zod_1.z.number().min(0).max(100),
    indicators: zod_1.z.array(zod_1.z.string()),
    sensitivityLevel: zod_1.z.enum(['low', 'medium', 'high', 'very_high']),
    approachStrategy: exports.PsychologicalApproachSchema,
});
// Response Framing (what gets sent to frontend)
exports.ResponseFramingSchema = zod_1.z.object({
    tone: zod_1.z.enum(['neutral', 'curious', 'empathetic', 'respectful']),
    approach: zod_1.z.enum(['direct', 'indirect', 'gradual', 'supportive']),
    emphasizeValidation: zod_1.z.boolean(),
    includeAlternatives: zod_1.z.boolean(),
    communityResources: zod_1.z.boolean(),
});
// Psychology Processing Result (INTERNAL ONLY)
exports.PsychologyProcessingResultSchema = zod_1.z.object({
    beliefSystemDetected: exports.BeliefSystemDetectionSchema.optional(),
    responseFraming: exports.ResponseFramingSchema,
    riskLevel: zod_1.z.enum(['low', 'medium', 'high', 'critical']),
    requiresReview: zod_1.z.boolean(),
    followUpRecommended: zod_1.z.boolean(),
});
// User Psychological Profile (INTERNAL ONLY - never stored with user ID)
exports.UserPsychologicalProfileSchema = zod_1.z.object({
    sessionId: zod_1.z.string(), // Anonymous session tracking only
    detectedPatterns: zod_1.z.array(zod_1.z.string()),
    responsiveness: zod_1.z.enum(['highly_receptive', 'moderately_receptive', 'resistant', 'hostile']),
    preferredApproaches: zod_1.z.array(exports.PsychologicalApproachSchema),
    topicSensitivities: zod_1.z.record(zod_1.z.enum(['low', 'medium', 'high', 'very_high'])),
    lastUpdated: zod_1.z.string().datetime(),
});
//# sourceMappingURL=psychology.js.map